import type { ArticleData } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';

export const SEARCH_ARTICLES_SUCCESS =
	'state.actions.search-articles-success.SEARCH_ARTICLES_SUCCESS' as const;

export type SearchArticlesSuccessPayload = ArticleData[];

export type SearchArticlesSuccessAction = {
	type: typeof SEARCH_ARTICLES_SUCCESS;
	payload: SearchArticlesSuccessPayload;
};

export const searchArticlesSuccess = (
	payload: SearchArticlesSuccessPayload,
): SearchArticlesSuccessAction => ({
	type: SEARCH_ARTICLES_SUCCESS,
	payload,
});
